const agendaDataList = [
    [{
            date: '11/16',
            tables: [{
                    title: 'Future Science Prize Lecture in Life Science',
                    subTitle: '(TBD)',
                    shortTit: 'Future Science Prize Lecture in Life Science',
                    table: [{
                        time: '',
                        text: 'Future Science Prize Lecture in Life Science',
                    }, ],
                },
                {
                    title: '2021 Future Science Prize Week and Science and Art Exhibition Opening Ceremony',
                    subTitle: 'Beijing, China',
                    shortTit: 'Opening Ceremony',
                    table: [{
                        time: '',
                        text: 'Opening Ceremony',
                    }, ],
                },
            ],
        },
        {
            date: '11/17',
            tables: [{
                title: 'Future Science Prize Lecture in Physical Science',
                subTitle: '(TBD)',
                shortTit: 'Future Science Prize Lecture in Physical Science',
                table: [],
            }, ],
        },
        {
            date: '11/18',
            tables: [{
                title: 'Future Science Prize Lecture in Mathematics and Computer Science',
                subTitle: '(TBD)',
                shortTit: 'Future Science Prize Lecture in Mathematics and Computer Science',
                table: [],
            }, ],
        },
        {
            date: '11/19',
            tables: [{
                title: 'Science Symposium',
                subTitle: 'Beijing, China',
                shortTit: 'Science Symposium',
                table: [

                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Liqun LUO</b>，Co-Chair, Program Committee of the Future Science Prize Week 2021; Ann and Bill Swindell Professor of Humanities and Sciences, Stanford University；Member, American Academy of Arts and Sciences；Member, U.S. National Academy of Sciences',
                                },
                            },
                            {
                                content: {
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Haifan LIN</b>, Member, Science Committee of the Future Science PrizeEugene Higgins Professor, Yale University; Founding Director, Yale Stem Cell Center; Founding Dean (adjunct), SLST, ShanghaiTech; Member, U.S. National Academy of Sciences; Member, American Academy of Arts and Sciences',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Hongkui DENG</b>, Professor, Peking University',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: 'Panel Dialogue ',
                            host: ' (Moderator Liqun LUO)',
                            guest: ['Haifan LIN, Hongkui DENG'],
                        }],
                        time: '08:30 - 09:40',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; "> [Life Science] - Stem Cells and Regenerative Medicine</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Hong DING</b>, Member, Steering Committee of the Future Science Prize Week; Future Forum Council; Professor, Institute of Physics, Chinese Academy of Sciences; Chief Scientist, Beijing National Laboratory for Condensed Matter Physics',
                                },
                            },
                            {
                                content: {
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jun YE</b>, Member, Science Committee of the Future Science Prize; Professor, University of Colorado, Boulder; Member, U.S. National Academy of Sciences; Foreign Member, Chinese Academy of Sciences',
                                },
                            },
                            {

                                content: {
                                    title: 'Keynote 2',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jiangfeng DU</b>, Professor, University of Science and Technology of China; Member, Chinese Academy of Sciences</span> ',
                                },
                            },
                            {

                                content: {
                                    title: 'Keynote 3',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jing ZHANG</b>, Professor, SHANXI University</span>',
                                },
                            },
                        ],
                        time: '09:45 - 11:05',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Physics]</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Kai LI</b>, Member, Science Committee of the Future Science Prize; Paul & Marcia Wythes Professor, Princeton University; Member, National Academy of Engineering; Foreign Member, Chinese Academy of Engineering',
                                },
                            },
                            {
                                content: {
                                    title: 'Keynote 1',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Ru HUANG</b>, Professor, Peking University; Member, Chinese Academy of Sciences',
                                },
                            },
                            {

                                content: {
                                    title: 'Keynote 2',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Ming LIU</b>, Professor, Institute of Microelectronics of the Chinese Academy of Sciences; Member, Chinese Academy of Sciences',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: 'Panel Dialogue ',
                            host: ' (Moderator Kai LI))',
                            guest: ['Ru HUANG, Ming LIU'],
                        }],
                        time: '11:10 - 12:20',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Computer Science] - Chips</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xiaoliang Sunney XIE</b>, Member, Steering Committee of the Future Science Prize Week; Future Forum Council; Lee Shau-kee Professor, Peking University; Director, Beijing Advanced Innovation Center for Genomics, Peking University; Director, BIOPIC, Peking University; Member, U.S. National Academy of Sciences; Member, U.S. National Academy of Medicine; Foreign Member, Chinese Academy of Sciences',
                                },
                            },
                            {
                                content: {
                                    title: 'Keynote 1',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Hesheng LIU</b>, Professor, Harvard University</b>',
                                },
                            },
                            {
                                content: {
                                    title: 'Keynote 2',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Luming LI</b>, Professor, Tsinghua University</span>',
                                },
                            },
                            {
                                content: {
                                    title: 'Keynote 3',
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jiahong GAO</b>, Professor, Peking University</span>',
                                },
                            },
                        ],
                        time: '14:00 - 15:20',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Life Science] - Functional Brain Imaging and Intervention</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Gang TIAN</b>, Member, Steering Committee of the Future Science Prize; Future Forum Council; Director, Beijing International Center for Mathematical Research; Member, Chinese Academy of Sciences; Member, U.S. Academy of Arts and Sciences',
                                },
                            },
                            {
                                content: {
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yongbin RUAN</b>, Professor, Zhejiang University',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jun LI</b>, Chair Professor, Fudan University',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: 'Panel Dialogue ',
                            host: ' (Moderator Gang TIAN)',
                            guest: ['Yongbin RUAN, Jun LI'],
                        }],
                        time: '15:25 - 16:35',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Mathematics] - Algebraic Geometry</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xiangping WU</b>, Member, Steering Committee of the Future Science Prize; Week Academician of National Astronomical Observatories, CAS; Member, Chinese Academy of Sciences',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;">Look For Livable Planets</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jilin ZHOU</b>, Professor, Nanjing University',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;"> Bioregenerative Life Support System</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Hong LIU</b>, Professor, Beihang University',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: 'Panel Dialogue ',
                            host: ' (Moderator Xiangping WU)',
                            guest: ['Jilin ZHOU, Hong LIU'],
                        }],
                        time: "16:40 - 17:50",
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Astronomy] - Livable Planets  </b></b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>Opening Remark</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Liqun LUO</b>, Co-Chair, Program Committee of the Future Science Prize Week 2021; Ann and Bill Swindell Professor of Humanities and Sciences, Stanford University；Member, American Academy of Arts and Sciences；Member, U.S. National Academy of Sciences',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Chuan HE</b>, Member, Science Committee of the Future Science Prize; John T. Wilson Distinguished Service Professor, University of Chicago; Investigator, Howard Hughes Medical Institute',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;"> Keynote Speech (TBD)</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xiangdong FU</b>, Professor, UCSD</span>',

                                },
                            },
                        ],
                        time: "20:00 - 21:00",
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Life Science] - RNA biology to future therapies</b></b>',
                    },
                ],
            }, ],
        },
        {
            date: '11/20 ',

            tables: [{
                    title: 'Science Symposium',
                    subTitle: 'Beijing, China ',
                    shortTit: 'Science Symposium',
                    table: [{
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Hong DING</b>, Member, Steering Committee of the Future Science Prize Week; Future Forum Council; Professor, Institute of Physics, Chinese Academy of Sciences; Chief Scientist, Beijing National Laboratory for Condensed Matter Physics',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xie CHEN</b>, Member, Science Committee of the Future Science Prize; Professor of Theoretical Physics, California Institute of Technology(Caltech) ',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yayu WANG</b>, Professor, Tsinghua University</b>',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xianhui CHEN</b>, Professor, University of Science and Technology of China, Chinese Academy of Sciences</b>',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Hongming WENG</b>, Professor, Institute of Physics, Chinese Academy of Sciences',
                                    },
                                },
                            ],
                            time: '08:30 - 09:55',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; "> [Physics]</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jianshu LI</b>, Co-Chair, Program Committee of the Future Science Prize Week 2021; Chair Professor, Zhejiang University; Member, Chinese Academy of Sciences',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yifeng LIU</b>, Professor, Zhejiang University ',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Zhiwei YUN</b>, Professor, MIT ',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: 'Panel Dialogue ',
                                host: ' (Moderator Jianshu LI)',
                                guest: ['Yifeng LIU, Zhiwei YUN'],
                            }],

                            time: '10:00 - 11:10',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; "> [Mathematics] - Number Theory</b>',
                        },

                        {
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xiangping WU</b>, Member, Science Committee of the Future Science Prize; Arthur and Gladys Pancoe Professor, Northwestern University',
                                    },
                                },
                                {
                                    content: {
                                        title: 'Keynote 1',
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yuk Ling YUNG</b>, Member, Science Committee of the Future Science Prize; Professor, Division of Geological and Planetary Sciences, California Institute of Technology; Member, American Academy of Arts and Sciences; Member, Academia Sinica',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Key Scientific Questions for Lunar and Deep Space Exploration</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Chi WANG</b>, Academician of National Space Science Center, the Chinese Academy of Sciences; Member, Chinese Academy of Sciences',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: 'Panel Dialogue ',
                                host: ' (Moderator Xiangping WU)',
                                guest: ['Yuk Ling YUNG, Chi WANG'],
                            }],

                            time: '11:15 - 12:25',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Astronomy] - Deep Space Exploration</b>',
                        },

                        {
                            arr: [{
                                    content: {
                                        class: '<span>Moderator</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Qian ZHENG</b>, Researcher, Shanghai Astronomical Observatory, CAS',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">The Origin and Evolution of the Universe</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xiangping WU</b>, Member, Steering Committee of the Future Science Prize; Week Academician of National Astronomical Observatories, CAS; Member, Chinese Academy of Sciences',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">The Universe in A Supercomputer</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jie WANG</b>, Researcher of National Astronomical Observatories, CAS',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: 'Panel Dialogue ',
                                host: ' (Moderator Qian ZHENG)',
                                guest: ['Xiangping WU, Jie WANG'],
                            }],
                            time: '14:00 - 15:10',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Astronomy] - Cosmogenesis</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jianshu LI</b>, Member, Co-Chair, Program Committee of the Future Science Prize Week 2021; Chair Professor, Zhejiang University; Member, Chinese Academy of Sciences',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Gang TIAN</b>, Member, Steering Committee of the Future Science Prize; Future Forum Council; Director, Beijing International Center for Mathematical Research; Member, Chinese Academy of Sciences; Member, U.S. Academy of Arts and Sciences</b>',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yi LIU</b>, Beijing International Center for Mathematical Research',
                                    },
                                },

                            ],
                            dialog: [{
                                hostTitle: 'Panel Dialogue ',
                                host: ' (Moderator Jianshu LI)',
                                guest: ['Gang TIAN, Yi LIU'],
                            }],
                            time: '15:15 - 16:25',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Mathematics] - Geometric Topology</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jianhua LIN</b>, Member, Steering Committee of the Future Science Prize; Former President of Peking University; Director of Peking University Research Center for Future Education Management and Professor of Chemistry',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Li DENG</b>, Member, Science Committee of the Future Science Prize; XU Yiming Endowed Chair Professor, Westlake University; Executive Dean of the School of Science, Westlake University',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yiqin GAO</b>, Professor, Peking University ',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: 'Panel Dialogue ',
                                host: ' (Moderator  Jianhua LIN)',
                                guest: ['Li DENG, Yiqin GAO'],
                            }],
                            time: '16:30 - 17:40',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Chemistry] - Organic Synthetic Molecule</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jianhua LIN</b>, Member, Steering Committee of the Future Science Prize; Former President of Peking University; Director of Peking University Research Center for Future Education Management and Professor of Chemistry',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Yi CUI</b>, Member, Science Committee of the Future Science Prize; Professor of Materials Science and Engineering, Stanford University; Director of Precourt Institute for Energy; Executive Editor, Nano Letters; Co-Director of Battery 500 Consortium',

                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Keynote Speech (TBD)</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Xiaodong ZOU</b>, Professor, Stockholm University',

                                    },
                                },
                            ],
                            time: '19:30 - 20:35',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Chemistry and Materials]</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>Opening Remark</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Kai LI</b>, Member, Science Committee of the Future Science Prize; Paul & Marcia Wythes Professor, Princeton University; Member, National Academy of Engineering; Foreign Member, Chinese Academy of Engineering',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Personalized neoantigen de novo sequencing in cancer immunotherapy</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Ming LI</b>, Member, Science Committee of the Future Science Prize; University Professor, University of Waterloo; Fellow, The Royal Society of Canada',

                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">Protein folding by deep learning</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">Jinbo XU</b>, Professor of Toyota Technological Institute at Chicago; Senior Fellow, Computational Institute at the University of Chicago',

                                    },
                                },
                            ],
                            time: '20:40 - 21:45',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">[Computer Science] - AI and Biotechnology</b>',
                        },
                    ],
                },

                {
                    title: 'Science Gala & Young scientist Innovation show',
                    subTitle: 'Beijing, China',
                    shortTit: 'Science Gala X Young Scientist Innovation Show',
                    table: [{
                        arr: [{
                            time: '18:30 - 20:30',
                            content: {
                                title: '',
                                class: '',
                                personIntro: 'Science Gala X Young Scientist Innovation Show (Invited only)',
                            },
                        }, ],
                        text: '',
                    }, ],
                },
            ],
        },
        {
            date: '11/21',
            tables: [{
                    title: 'Public Lectures by Award Laureates & Award Laureates Meet K12 Students',
                    subTitle: 'Beijing, China',
                    shortTit: 'Public Lectures by Award Laureates & Award Laureates Meet K12 Students',
                    table: [{
                        arr: [{
                            content: {
                                title: '',
                                class: '',
                                personIntro: '',
                            },
                        }, ],
                        text: 'Public Lectures by Award Laureates & Award Laureates Meet K12 Students',
                        time: '09:00 - 12:00'
                    }, ]
                },
                {
                    title: 'Future Science Prize Award Ceremony',
                    subTitle: 'Beijing, China ',
                    shortTit: 'Award Cremony',
                    table: [{
                            arr: [{
                                time: '18:30 - 22:00',
                                content: {
                                    title: '',
                                    class: '',
                                    personIntro: 'Charity Dinner (Invited only)',
                                },
                            }, ],
                            time: '15:30 - 18:00',
                            text: 'Award Ceremony',
                        },

                    ],
                },
            ],
        },
    ],
];
const text = {
    title: 'Program of 2021 Future Science Prize Week',
    subTitle: ''
};

const context = {
    title: 'Future Science Prize Week 2021',
    content: `<p style="margin: 0; line-height: 2rem">
	The 2021 Future Science Prize Week this year will be a 6-day event in Beijing from November 16th -21st.
	</p>
	<p style="margin: 0; line-height: 2rem">
		The main activities include:
	 	<b style="color: #010824">Public Lectures of Future Science Prize:</b>
		  the laureates of the three prizes in life science, material science, mathematics and computer science will explain their achievements; 
		<b style="color: #010824" >Dialogue: Future Science Prize Laureates with K12 Students:</b>
		  to provide an opportunity for more young people who love science to communicate with scientists face to face and inspire the future generation to embark on the path of scientific research and scientific innovation; 
		<b style="color: #010824" >Future Science Award Ceremony:</b>
			honors scientists who have made significant scientific research achievements for all mankind, witnessing the moment of glory of the award winners;
		<b style="color: #010824" >Symposium:</b
	> world-renowned scientists share their cutting-edge scientific achievements, discuss academic innovation and share scientific achievements together.
	</p>
	`
};

const steePersonList = [
    'Jason CONG',
    'Hong DING',
    'Jianhua LIN',
    'Gang TIAN',
    'Xiangping WU',
    'Xiaoliang Sunney XIE ',
]
const programPersonList = [
    'Jian-shu LI(Co-chair)',
    'Liqun LUO(Co-chair)',
    'Eric CHEN',
    'Feng DENG',
    'James DING',
    'Chuan HE',
    'Kai LI',
    'Ming LI',
    'Haifan LIN',
    'Xiaole Shirley LIU',
    'Xiaodong WANG',
    'Shouwu ZHANG',
    'Xiaodong ZHANG',
]
const live2019 = [{
        title: "2019 Future Science Award",
        etitle: "Future Science Award",
        time: '12/27',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award1",
        etitle: "Future Science Award",
        time: '12/28',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title1",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award2",
        etitle: "Future Science Award",
        time: '12/29',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title2",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award3",
        etitle: "Future Science Award",
        time: '12/30',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title3",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
]
const live2020 = [{
        title: "2020 Future Science Award",
        etitle: "Future Science Award",
        time: '12/27',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award1",
        etitle: "Future Science Award",
        time: '12/28',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title1",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award2",
        etitle: "Future Science Award",
        time: '12/29',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title2",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award3",
        etitle: "Future Science Award",
        time: '12/30',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title3",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
]
const live2021 = [{
        title: "2021 Future Science Award",
        etitle: "Future Science Award",
        time: '12/27',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award1",
        etitle: "Future Science Award",
        time: '12/28',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title1",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award2",
        etitle: "Future Science Award",
        time: '12/29',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title2",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "Future Science Award3",
        etitle: "Future Science Award",
        time: '12/30',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title3",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
]
const en = {
    agendaDataList,
    text,
    context,
    steePersonList,
    programPersonList,
    live2019,
    live2020,
    live2021,
}


export default en;